var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-326 -568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M335.519,568a9.5,9.5,0,0,1,8.657,13.366l1.773,5.318a1,1,0,0,1-1.265,1.265l-5.318-1.773a9.439,9.439,0,0,1-3.847.824H335.5a9.509,9.509,0,0,1-9.5-9.5V577q0-.028,0-.055A9.481,9.481,0,0,1,334.945,568l.055,0Zm7.9,17.419-1.268-3.8a1,1,0,0,1,.056-.767A7.421,7.421,0,0,0,343,577.5a7.509,7.509,0,0,0-7.481-7.5h-.491A7.481,7.481,0,0,0,328,577.028v.472a7.506,7.506,0,0,0,7.5,7.5h.018a7.421,7.421,0,0,0,3.33-.793,1,1,0,0,1,.767-.056Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.4697f7f92b4fae74b56eb46521006139.svg";
export { ForwardRef as ReactComponent };